import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form,
    Row,
    Col,
    Modal,
    message,
    Popconfirm,
    Spin,
    Select,
    Button,
    Icon,
    Table,
    Input,
    InputNumber,
    DatePicker,
    TimePicker,
    Radio,
    Checkbox,
    Calendar,
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { dateConversion, timeConversion, getDateBetween, showDate } from '../../../utils';
import { getHostList,modifyHost,createHostAction,createStatusAction,addList,createAddListStatusAction } from './actions';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

let dataArray = [];
let user = JSON.parse(localStorage.getItem('HippoUserInfo'));
let today = dateConversion(Date.parse(new Date()));
let listData = [];

class AddList extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            confirmLoading: false
        };
    }
    componentDidMount() {
    }


    // async handleInterstChange(value) {
    //   console.log('aaaa',value);
    // };
    //
    // async handleUserInfoChange(value) {
    //
    // };

    changeAddHide = () => {
        this.props.changeAddListStatus(false);
        this.props.form.resetFields();
    };

    async submit(i) {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    this.setState({confirmLoading: true});
                    await this.props.addList(fieldsValue.ipList)
                    await this.props.form.resetFields();
                    await this.changeAddHide();
                    await this.props.GetHostList();
                    this.setState({confirmLoading: false});
                } catch (err) {
                    console.log(err);
                    this.setState({confirmLoading: false});
                    alert(err);
                }
            } else {
                this.setState({confirmLoading: false});
                console.log(err);
            }
        });
    };
    render() {
        const { getFieldDecorator, onPanelChange } = this.props.form;
        const { status } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };
        return (
            <div>
                <Modal
                    title={'批量添加主机'}
                    visible={status == true}
                    confirmLoading={this.state.confirmLoading}
                    onCancel={() => this.changeAddHide()}
                    onOk={() => {
                        this.submit();
                    }}>
                    <Form>
                      <FormItem {...formItemLayout} label="ip文本">
                          {getFieldDecorator('ipList', {
                          })(<TextArea placeholder="输入的ip必须以换行符为分隔符!!!" />)}
                      </FormItem>
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    status: state.hostList.addListStatus
});

const mapDispatchToProps = dispatch => ({
  GetHostList: prarms => dispatch(getHostList()),
  ModifyHost: prarms => dispatch(modifyHost(prarms)),
  addList: prarms => dispatch(addList(prarms)),
  storeHost: param => dispatch(createHostAction(param)),
  changeAddListStatus: status => dispatch(createAddListStatusAction(status)),
  changeStatus: status => dispatch(createStatusAction(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddList));



// WEBPACK FOOTER //
// ./pages/assist/hostManage/addList.js